class ProductInfoObservers {
  constructor() {
    this.MIN_WIDTH = 1100;
    this.POSITION_OFFSET = 55;

    this.overlayStop = document.querySelector('#ProductOverlayStop');
    this.overlay = document.querySelector('.product__info-container');
    this.header = document.querySelector('.header');
    this.announcementBar = document.querySelector('.announcement-bar');
    this.overlayHeight = this.overlay?.offsetHeight || 0;
    this.headerHeight = this.header?.offsetHeight || 0;
    this.announcementBarHeight = this.announcementBar?.offsetHeight || 0;
    this.intersectingOverlayStop = false;
    this.overlayPositionOffset = this.headerHeight + this.POSITION_OFFSET;
    this.overlayActive = false;

    if (!this.overlayStop) return this.setOverlayAsStatic();

    this.determinePositionType();
    this.initiateObservers();
  }

  isViableViewportSize() {
    return window.innerWidth >= this.MIN_WIDTH && window.innerHeight > (this.overlayHeight + this.overlayPositionOffset);
  }

  initiateObservers() {
    this.debouncedObserveProductInfo = debounce(() => this.observeProductInfo());
    this.debouncedHandleResize = debounce(() => this.determinePositionType());

    window.addEventListener("scroll", this.debouncedObserveProductInfo);
    window.addEventListener("resize", this.debouncedHandleResize);

    this.observeProductInfo();
  }

  determinePositionType() {
    this.updateVariables();

    if (!this.isViableViewportSize()) {
      return this.setOverlayAsStatic();
    }

    this.overlayActive = true;
  }

  updateVariables() {
    this.overlayHeight = this.overlay?.offsetHeight || 0;
    this.headerHeight = this.header?.offsetHeight || 0;
    this.overlayPositionOffset = this.headerHeight + this.POSITION_OFFSET + this.announcementBarHeight;
    this.overlayPositionOffsetAbsolute = this.headerHeight + this.POSITION_OFFSET;

    const availableSpace = (window.innerHeight - this.overlayPositionOffsetAbsolute - this.overlayHeight) / 2;

    this.overlayPositionOffset = this.overlayPositionOffset + availableSpace;
  }

  setOverlayAsStatic() {
    const isMobile = window.matchMedia("(max-width: 989px)").matches;

    this.overlay.style.position = isMobile ? "static" : "absolute";
    this.overlay.style.top =  this.overlayPositionOffsetAbsolute + "px";

    this.overlayActive = false;
  }

  observeProductInfo() {
    if (!this.overlayActive) return;

    const overlayRect = this.overlay.getBoundingClientRect();
    const overlayStopRect = this.overlayStop.getBoundingClientRect();

    this.overlay.style.transform = "none";

    this.setOverlayStyle("fixed", this.overlayPositionOffset + "px");

    if (this.isIntersectingOverlayStop(overlayRect, overlayStopRect)) {
      this.intersectingOverlayStop = true;

      this.setOverlayStyle(
        "absolute",
        window.scrollY + (overlayStopRect.bottom - this.overlayHeight - this.POSITION_OFFSET) + "px"
      );
    }

    if (this.shouldResetOverlay(overlayRect)) {
      this.intersectingOverlayStop = false;

      this.setOverlayStyle('fixed', this.overlayPositionOffset + "px");
    }
  }

  isIntersectingOverlayStop(overlayRect, overlayStopRect) {
    return overlayRect.bottom + this.POSITION_OFFSET >= overlayStopRect.bottom;
  }

  shouldResetOverlay(overlayRect) {
    return this.intersectingOverlayStop && overlayRect.top > this.overlayPositionOffset;
  }

  setOverlayStyle(position, top) {
    Object.assign(this.overlay.style, { position, top });
  }
}

new ProductInfoObservers();



